import { useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import { Box, Grid, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchGroupSelection,
    fetchGroupsByIds,
    makeFetchGroupsPage,
} from '../../../../helpers/Groups/pagedGroups';
import { PagedGroupsFilter } from '../../../../hooks/useServerPagedGroups';
import Groups from '../../../../components/Groups/GroupsHandler/Groups';
import { Group } from '../../../../Models/Groups/Group';

const SubscriberGroup = ({ classes, data, onUpdate, onShowTestGroups, errors }: any) => {
    const dispatch: any = useDispatch();
    const { testGroups } = useSelector((state: any) => state.sms);
    // PR-3790: the picker pages its own rows instead of receiving the whole list.
    const fetchGroupsPage = useMemo(() => makeFetchGroupsPage(dispatch), [dispatch]);
    const [showTestGroups, setShowTestGroups] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState<any>([]);
    const [allGroupsSelected, setAllGroupsSelected] = useState(false);

    const callbackUpdateGroups = (groups: any) => {
        const found = selectedGroups.map((group: Group) => { return group.GroupID; }).includes(groups.GroupID);
        const groupList: Group[] = found
            ? selectedGroups.filter((g: Group) => g.GroupID !== groups.GroupID)
            : [...selectedGroups, groups];
        setSelectedGroups(groupList);
        onUpdate({ ...data, GroupIDs: groupList.map(g => g.GroupID.toString()) })
    }

    // PR-3790: the browser no longer holds every group, so selecting everything
    // asks the server for the matching ids using the picker's current filter.
    const callbackSelectAll = async (filter?: PagedGroupsFilter) => {
        let groupList: Group[] = [];
        if (!allGroupsSelected) {
            const selection = await fetchGroupSelection(dispatch, filter);
            const fromServer = selection.groups;
            groupList = [...fromServer, ...(showTestGroups ? testGroups : [])] as Group[];
        }
        setSelectedGroups(groupList);
        setAllGroupsSelected(!allGroupsSelected);
        onUpdate({ ...data, GroupIDs: groupList.map(g => g.GroupID.toString()) })
    }

    const onRemoveGroup = (leftGroups: Group[]) => {
        if (leftGroups && leftGroups?.length > 0) {
            setSelectedGroups(leftGroups);
            onUpdate({ ...data, GroupIDs: leftGroups.map(g => g.GroupID.toString()) })
        }
        else {
            setSelectedGroups([]);
            onUpdate({ ...data, GroupIDs: [] })
        }
    }

    // PR-3790: the saved GroupIDs used to be matched against the complete
    // downloaded list. With the list paged, the server is asked for those groups.
    useEffect(() => {
        let cancelled = false;
        (async () => {
            const savedIds: string[] = data?.GroupIDs || [];
            if (savedIds.length === 0) return;
            const groups = await fetchGroupsByIds(dispatch, savedIds.map((x) => x.trim()));
            if (!cancelled) setSelectedGroups(groups);
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data?.GroupIDs]);

    return (
        <Box>
            <Groups
                classes={classes}
                list={[]}
                fetchPage={fetchGroupsPage}
                // @ts-ignore
                showTestGroups={false}
                // test={showTestGroups}
                selectedList={selectedGroups}
                //@ts-ignore
                callbackSelectedGroups={callbackUpdateGroups}
                //@ts-ignore
                callbackSelectAll={callbackSelectAll}
                //@ts-ignore
                callbackShowTestGroup={() => onShowTestGroups(!showTestGroups)}
                callbackUpdateGroups={onRemoveGroup}
                showSortBy={true}
                showFilter={false}
                showSelectAll={true}
                isFilterSelected={false}
                bsDot={null}
                isNotifications={false}
                isSms={false}
                isCampaign={false}
                noSelectionText={''}
                //@ts-ignore
                innerHeight={325}
            />
            <Box className='textBoxWrapper'>
                <Typography className={clsx(errors.group ? classes.errorText : 'MuiFormHelperText-root', classes.f14)}>
                    {errors.group ?? errors.group}
                </Typography>
            </Box>
        </Box>
    )
}

export default SubscriberGroup;